import { Typography, Drawer, Theme, Grid } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

interface IProps {
    children: React.ReactNode
    sidebarOpen: boolean
    caption: string
    menuSide: 'left' | 'right'

    closeSidebar: () => void
}

let useStyles = makeStyles()((theme: Theme) => ({
    content: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        width: 256
    },
    menuHeader: {
        height: 48,
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    }
}));

let FiltersMenuContainer = ({ children, sidebarOpen, caption, menuSide, closeSidebar }: IProps) => {
    let { classes } = useStyles();

    return (
        <Drawer
            anchor={menuSide}
            onClose={closeSidebar}
            open={sidebarOpen}
            variant="temporary"
        >
            <>
                <Grid container>
                    <Grid item xs={12} className={classes.menuHeader}>
                        <Typography variant="body1">{caption}</Typography>
                    </Grid>
                </Grid>
                <div className={classes.content}>
                    {children}
                </div>
            </>
        </Drawer>
    )
}


export default FiltersMenuContainer;